<template>
<div class="chapter">
<div class="inner_page">
<h3 class="calibre4">I.</h3>
<p class="calibre1">Andere hätten ein Buch daraus machen können; aber die
Geschichte, die ich hier erzähle, habe ich mit meiner ganzen Kraft
gelebt, und meine Tugend hat sich in ihr verbraucht. Ich werde also
ganz einfach meine Erinnerungen niederschreiben, und wenn sie
stellenweise in Fetzen gegangen sind, so werde ich zu keiner
Erfindungskraft greifen, um sie zusammenzustücken oder zu
verbinden; die Mühe, die ich auf ihre Zurüstung verwenden müßte,
würde die letzte Freude schmälern, die ich mir durch den einfachen
Bericht verspreche.</p>
<p class="calibre1">Ich war noch nicht zwölf Jahre alt, als ich meinen Vater verlor.
Meine Mutter, die nichts mehr in Le Havre zurückhielt, wo mein
Vater Arzt gewesen war, beschloß, nach Paris zu ziehen, da sie
glaubte, ich würde dort meine Studien besser abschließen können.
Sie mietete in der Nähe des Luxembourg eine kleine Wohnung, die Miß
Ashburton mit uns teilen wollte. <a class="pcalibre2 pcalibre1 pcalibre pcalibre3" id="page8" title="ECeDee/Dieter7"></a> Miß Flora Ashburton, die keine Familie mehr
hatte, war ursprünglich die Gouvernante meiner Mutter gewesen; dann
ihre Gesellschafterin und bald auch ihre Freundin. Ich lebte bei
diesen beiden Frauen mit dem gleichermaßen sanften und traurigen
Ausdruck. Eines Tages, ich glaube, es war ziemlich lange nach dem
Tode meines Vaters, tat meine Mutter an die Stelle des schwarzen
Bandes ihrer Morgenhaube ein malvenfarbiges Band.</p>
<p class="calibre1">»O Mama!« rief ich naiv aus; »wie schlecht dir diese Farbe
steht!«</p>
<p class="calibre1">Am folgenden Morgen trug sie wieder ein schwarzes Band.</p>
<p class="calibre1">Meine Gesundheit war zart. Wenn die Pflege meiner Mutter und Miß
Ashburtons, deren ganze Sorge es war, jeder Ermattung bei mir
zuvorzukommen, keinen Faulpelz aus mir gemacht hat, so liegt es
daran, daß ich wirklich Geschmack an der Arbeit finde. Kaum sind
die ersten schönen Tage da, so überreden sie einander, daß es für
mich Zeit ist, die Stadt zu verlassen, daß ich dort bleich werde;
um Mitte Juni brechen wir nach Fongueusemare in der <a class="pcalibre2 pcalibre1 pcalibre pcalibre3" id="page9" title="ECeDee/Dieter7"></a> Umgegend von Le Havre auf,
wo wir alljährlich bei meinem Onkel Bucolin zu Gast sind.</p>
<p class="calibre1">In einem nicht sehr großen, nicht sehr schönen Garten, den
nichts eigentlich Besonderes von einer Fülle anderer normannischer
Gärten unterscheidet, gleicht dieses weiße, zweistöckige Haus der
Bucolins vielen Landhäusern des letzten Jahrhunderts. Es öffnet
sich mit etwa zwanzig großen Fenstern gen Osten auf den Vorgarten;
mit gleich vielen nach hinten; seitlich hat es gar keine. Die
Fenster bestehen aus kleinen Scheiben; einige sind jüngst erneuert
und scheinen zu hell neben den alten, die in ihrer Nähe grün und
trüb aussehen. Manche haben Fehler, die unsere Verwandten »Blasen«
nennen; der Baum, den man durch diese sieht, wird schlottrig; wenn
der Briefbote vorübergeht, bekommt er jählings einen Buckel.</p>
<p class="calibre1">Der rechteckige Garten ist von Mauern umgeben. Er bildet vor dem
Hause eine ziemlich kleine, beschattete Wiese, die ein mit Sand und
Kies bestreuter Weg umläuft. Auf dieser Seite senkt sich die Mauer,
um den Blick auf den Pachthof zu gestatten, der den Garten
umschließt und dessen Grenze nach Landesbrauch eine <a class="pcalibre2 pcalibre1 pcalibre pcalibre3" id="page10" title="ECeDee/Dieter7"></a> Buchenallee bildet.
Zwischen den Flanken des Hauses und den Mauern hat die plötzliche
Verengung des Gartens nicht mehr Raum gelassen, als daß man einen
Gang einschmuggeln und mit Hilfe hoher Büsche und rankenden Efeus
die blinde Mauerwand ein wenig verkleiden konnte.</p>
<p class="calibre1">Hinter dem Hause, im Westen, entfaltet sich der Garten
behaglicher. Vor den Spalieren im Süden wird ein von Blumen
lachender Gang durch einen dichten Vorhang portugiesischen
Kirschlorbeers und einige Bäume geschirmt. Ein anderer Gang an der
Nordmauer hin verschwindet unter den Zweigen. Meine Kusinen nannten
ihn »den schwarzen Gang« und wagten sich nicht gern mehr hin, wenn
die Abenddämmerung vorüber war. Diese beiden Gänge führen zum
Küchengarten, der, tiefer gelegen, den Garten fortsetzt, nachdem
man ein paar Stufen hinabgestiegen ist. Dann, auf der anderen Seite
der Mauer, die im Hintergrund des Küchengartens von einer kleinen
Geheimpforte durchbrochen wird, findet man ein kleines Buschholz,
in das von rechts und links die Buchenallee einmündet. Von der
westlichen Freitreppe aus bewundert der Blick, wenn er über dieses
<a class="pcalibre2 pcalibre1 pcalibre pcalibre3" id="page11" title="ECeDee/Dieter7"></a> Dickicht
hinweg die Hochebene wiederfindet, die Ernte, die sie bedeckt. Am
nicht sehr fernen Horizont die Kirche eines kleinen Dorfes und
abends, wenn die Luft ruhig ist, der Rauch einiger Häuser.</p>
<p class="calibre1">An jedem schönen Sommerabend stiegen wir damals nach dem Essen
in den unteren Garten hinab. Wir gingen durch die kleine
Geheimpforte zu einer Bank der Allee, von der aus man die Gegend
ein wenig beherrscht; dort, dicht bei dem Strohdach einer
aufgegebenen Mergelgrube, setzten sich mein Onkel, meine Mutter und
Fräulein Ashburton; vor uns füllte sich das kleine Tal mit Dunst,
und der Himmel wurde über den ferneren Wäldern golden. Dann
zauderten wir im Hintergrund des schon düsteren Gartens. Wir
kehrten ins Haus zurück und fanden im Salon meine Tante, die fast
nie mit uns hinausging … Für uns Kinder schloß damit der
Abend; aber oft waren wir noch in unseren Zimmern damit
beschäftigt, zu lesen, wenn wir später unsere Eltern heraufkommen
hörten.</p>
<p class="calibre1">Zu fast allen Stunden des Tages, die wir nicht im Garten
verbrachten, hielten wir uns im »Schulsaal« auf, meines Onkels
Arbeitszimmer, <a class="pcalibre2 pcalibre1 pcalibre pcalibre3" id="page12" title="ECeDee/Dieter7"></a> wo man Schulpulte aufgestellt hatte. Mein
Vetter Robert und ich arbeiteten Seite an Seite; hinter uns
Juliette und Alissa. Alissa ist zwei Jahre älter, Juliette ein Jahr
jünger als ich; Robert ist von uns Vieren der jüngste.</p>
<p class="calibre1">Nicht meine ersten Erinnerungen gedenke ich hier
niederzuschreiben; nur die, die sich auf diese Geschichte beziehen.
Ich kann sagen, daß sie eigentlich mit dem Todesjahr meines Vaters
beginnt. Vielleicht machte mich meine Empfindlichkeit, die durch
unsere Trauer, und wenn nicht durch meinen eigenen Kummer, so doch
durch den Anblick des Kummers meiner Mutter überreizt war, für neue
Erregungen empfänglich: ich war vorzeitig gereift; als wir in
diesem Jahr nach Fongueusemare zurückkehrten, schienen mir Juliette
und Robert nur um so jünger, – aber als ich Alissa wiedersah,
begriff ich jählings, daß wir beide aufgehört hatten, Kinder zu
sein.</p>
<p class="calibre1">Ja, es ist das Todesjahr meines Vaters; meine Erinnerung wird
bestätigt durch eine Unterhaltung meiner Mutter mit Miß Ashburton
gleich nach unserer Ankunft. Ich war unvermutet in das Zimmer
getreten, wo meine Mutter mit ihrer <a class="pcalibre2 pcalibre1 pcalibre pcalibre3" id="page13" title="ECeDee/Dieter7"></a> Freundin plauderte; es handelte sich um
meine Tante; meine Mutter entrüstete sich darüber, daß sie keine
Trauer angelegt oder sie schon wieder abgelegt hatte. (Es ist mir
freilich ebenso unmöglich, mir meine Tante Bucolin in Schwarz
vorzustellen wie meine Mutter in hellen Kleidern.) An jenem Tage
unserer Ankunft trug Lucilie Bucolin, soweit ich mich entsinne, ein
Musselinkleid. Miß Ashburton, die wie immer versöhnlich war,
bemühte sich, meine Mutter zu beruhigen; sie machte schüchtern
geltend:</p>
<p class="calibre1">»Schließlich ist Weiß auch Trauer.«</p>
<p class="calibre1">»Und nennen Sie den roten Schal, den sie über die Schultern
geworfen hat, auch Trauer? Flora, Sie empören mich!« rief meine
Mutter aus.</p>
<p class="calibre1">Ich sah meine Tante nur während der Ferienmonate, und ohne
Zweifel motivierte die Hitze des Sommers jene leichten und weit
offenen Mieder, die ich stets an ihr gekannt habe. Aber mehr noch
als die brennende Farbe der Tücher, die meine Tante sich über die
nackten Schultern warf, erregte diese Dekolletierung bei meiner
Mutter Ärgernis. <a class="pcalibre2 pcalibre1 pcalibre pcalibre3" id="page14" title="ECeDee/Dieter7"></a></p>
<p class="calibre1">Lucilie Bucolin war sehr schön. Ein kleines Porträt von ihr, das
ich aufbewahrt habe, zeigt sie mir, wie sie damals war; sie sieht
so jung aus, daß man sie für die ältere Schwester ihrer Töchter
halten könnte, wie sie seitlich dasitzt in jener ihr eigentümlichen
Haltung: den Kopf auf die linke Hand geneigt, den kleinen Finger
mutwillig zur Lippe niedergebogen. Ein weitmaschiges Netz hält die
Masse ihres gekräuselten Haares, das halb in den Nacken gesunken
ist; im runden Ausschnitt des Mieders hängt an einem lockeren
Halsband aus schwarzem Samt ein Medaillon aus italienischem Mosaik.
Der Gürtel aus schwarzem Samt mit der breiten, fließenden Schleife,
der breitrandige Hut aus biegsamem Stroh, den sie mit dem Band über
den Stuhlrand gehängt hat, alles steigert ihren kindlichen
Ausdruck. Die gesenkte rechte Hand hält ein geschlossenes Buch.</p>
<p class="calibre1">Lucilie Bucolin war Kreolin; sie hatte ihre Eltern nicht gekannt
oder sehr früh verloren. Meine Mutter erzählte mir später, daß sie
als Ausgesetzte oder Waise im Hause des Pastors Vautier Aufnahme
fand, der noch keine Kinder hatte und der, als er Martinique bald
darauf <a class="pcalibre2 pcalibre1 pcalibre pcalibre3" id="page15" title="ECeDee/Dieter7"></a>
verließ, dieses mit nach Le Havre nahm, wo die Familie Bucolin
ansässig war. Die Vautiers und die Bucolins verkehrten miteinander;
mein Onkel war damals im Ausland an einer Bank angestellt, und erst
drei Jahre später, als er zu den Seinen zurückkehrte, sah er die
kleine Lucilie; er verliebte sich in sie und bat alsbald zum großen
Kummer seiner Eltern und meiner Mutter um ihre Hand. Lucilie war
damals sechzehn Jahre alt. Inzwischen hatte Frau Vautier zwei
Kinder geboren; sie begann für sie den Einfluß dieser
Adoptivschwester zu fürchten, deren Charakter sich von Monat zu
Monat als immer wunderlicher herausstellte. Zudem waren die Mittel
des Haushalts mager … All das sagte mir meine Mutter, um mir
zu erklären, weshalb die Vautiers die Werbung ihres Bruders mit
Freuden angenommen hatten. Ich vermute obendrein, daß die junge
Lucilie ihnen furchtbare Verlegenheiten zu bereiten begann. Ich
kenne die Gesellschaft von Le Havre genau genug, um mir den
Empfang, den man diesem so verführerischen Kind bereitete, leicht
vorzustellen. Pastor Vautier, den ich später als sanft und zugleich
umsichtig und naiv, als wehrlos <a class="pcalibre2 pcalibre1 pcalibre pcalibre3" id="page16" title="ECeDee/Dieter7"></a> gegen die Intrige und waffenlos vor dem Übel
kennen lernte – dieser ausgezeichnete Mann mußte wie verraten sein.
Über Frau Vautier kann ich nichts sagen; sie starb bei der
Entbindung von einem vierten Kind, dem Sohn, der ungefähr mein
Altersgenosse war und später mein Freund werden sollte …</p>
<p class="calibre1">Lucilie Bucolin nahm nur wenig an unserem Leben teil; sie kam
erst nach der Mittagsmahlzeit aus ihrem Zimmer herab; sie streckte
sich alsbald auf einem Sofa oder in einer Hängematte aus, blieb bis
zum Abend liegen und erhob sich nur schläfrig. Sie hob zuweilen ein
Tuch an ihre gleichwohl vollkommen glanzlose Stirn, als wollte sie
eine Feuchtigkeit abwischen: es war ein Taschentuch, dessen
Feinheit mich erstaunte und dessen Geruch mehr der Duft einer
Frucht als einer Blume zu sein schien; bisweilen zog sie aus ihrem
Gürtel einen winzigen Spiegel mit drehbarem Silberdeckel, der mit
verschiedenen Kleinigkeiten an ihrer Uhrkette hing; sie sah sich
an, berührte mit einem Finger ihre Lippen, nahm ein wenig Speichel
auf und befeuchtete sich die Augenwinkel. Oft hielt sie ein Buch,
aber ein fast stets <a class="pcalibre2 pcalibre1 pcalibre pcalibre3" id="page17" title="ECeDee/Dieter7"></a> geschlossenes Buch; in dem Buch haftete ein
Lesezeichen aus Schildpatt zwischen den Blättern. Wenn man ihr
nahte, so wandte ihr Blick sich nicht von ihrer Träumerei ab, um
einen zu sehen. Oft fiel aus ihrer entweder unachtsamen oder
ermatteten Hand, von der Sofalehne oder von einer Falte ihres
Rockes das Tuch zu Boden; oder auch das Buch oder irgendeine Blume
oder das Lesezeichen. Als ich eines Tages das Buch aufhob – ich
rede hier von der Erinnerung eines Kindes – und sah, daß es Verse
waren, errötete ich.</p>
<p class="calibre1">Abends nach dem Essen kam Lucilie Bucolin nicht an unseren
Familientisch, sondern, am Piano sitzend, spielte sie
selbstgefällig langsame Chopinsche Mazurkas; bisweilen unterbrach
sie den Rhythmus und verweilte reglos auf einem Akkord …</p>
<p class="calibre1">Ich empfand ein sonderbares Unbehagen in der Nähe meiner Tante,
ein Gefühl, gemischt aus Unruhe, einer gewissen Bewunderung und
Angst. Vielleicht nahm mich ein dunkler Instinkt gegen sie ein;
dann fühlte ich, daß sie Flora Ashburton und meine Mutter
verachtete, <a class="pcalibre2 pcalibre1 pcalibre pcalibre3" id="page18" title="ECeDee/Dieter7"></a> daß Fräulein Ashburton sie fürchtete und
meine Mutter sie nicht liebte.</p>
<p class="calibre1">Lucilie Bucolin, ich möchte dir nicht mehr grollen, einen
Augenblick vergessen, daß du so viel Unrecht getan hast …
Wenigstens will ich versuchen, ohne Zorn von dir zu reden.</p>
<p class="calibre1">An einem Tage dieses Sommers – oder des folgenden Sommers, denn
bei dieser stets gleichen Umgebung verwirren sich zuweilen meine
übereinander geschichteten Erinnerungen – trete ich in den Salon,
um ein Buch zu holen; sie ist dort; ich will mich auf der Stelle
zurückziehen; doch sie, die mich für gewöhnlich kaum zu sehen
scheint, ruft mich:</p>
<p class="calibre1">»Weshalb gehst du so schnell? Jerome! Flöße ich dir Angst
ein?«</p>
<p class="calibre1">Mit klopfendem Herzen trete ich zu ihr; ich gewinne es über
mich, ihr zuzulächeln und ihr die Hand hinzustrecken. Sie hält
meine Hand in einer der ihren zurück und streichelt mir mit der
anderen die Wange.</p>
<p class="calibre1">»Wie schlecht deine Mutter dich anzieht, mein armer
Kleiner …!«</p>
<p class="calibre1">Ich trug damals eine Art Matrosenbluse mit <a class="pcalibre2 pcalibre1 pcalibre pcalibre3" id="page19" title="ECeDee/Dieter7"></a> breitem Kragen, den meine
Tante zu zerknittern beginnt.</p>
<p class="calibre1">»Matrosenkragen trägt man viel weiter offen,« sagt sie, indem
sie einen Knopf meines Hemdes aufspringen läßt. »Da! Sieh, bist du
so nicht viel hübscher?« Und indem sie ihren Spiegel hervorzieht,
zieht sie mein Gesicht an ihres, legt mir den nackten Arm um den
Hals, läßt ihre Hand in mein halb offenes Hemd hinabgleiten, fragt
lachend, ob ich kitzlich bin, dringt weiter vor … Ich schrak
so jäh zusammen, daß meine Matrosenbluse zerriß; mit flammendem
Gesicht und während sie rief: »Pfui, was für ein großer Dummkopf!«
entfloh ich; ich lief bis hinab in den Garten hinein; dort benetzte
ich in einer kleinen Zisterne des Gemüsegartens mein Taschentuch,
legte es mir auf die Stirn und wusch und rieb meine Wangen, meinen
Hals und alles, was diese Frau berührt hatte.</p>
<p class="calibre1">An gewissen Tagen hatte Lucilie Bucolin ihre »Krise«. Das packte
sie plötzlich und brachte das ganze Haus in Aufruhr. Miß Ashburton
beeilte sich, die Kinder fortzuführen und zu <a class="pcalibre2 pcalibre1 pcalibre pcalibre3" id="page20" title="ECeDee/Dieter7"></a> beschäftigen; aber man konnte
um ihretwillen nicht die grauenhaften Schreie ersticken, die aus
dem Schlafzimmer oder aus dem Salon hervordrangen. – Mein Onkel
wurde wahnsinnig; man hörte ihn in den Gängen laufen, nach
Handtüchern, Kölnischem Wasser oder Äther suchen; abends bewahrte
er bei Tisch, wo meine Tante noch nicht wieder erschien, eine
besorgte und gealterte Miene.</p>
<p class="calibre1">Wenn die Krise annähernd vorüber war, rief Lucilie Bucolin ihre
Kinder zu sich; wenigstens Robert und Juliette; Alissa nie. An
solchen traurigen Tagen schloß Alissa sich in ihrem Zimmer ein, wo
ihr Vater sie zuweilen aufsuchte, denn er plauderte oft mit
ihr.</p>
<p class="calibre1">Die Krisen meiner Tante machten einen tiefen Eindruck auf die
Dienstboten. Eines Abends, als die Krisis besonders stark gewesen
und ich bei meiner Mutter geblieben war, auf ihr Zimmer beschränkt,
in dem man weniger deutlich merkte, was im Salon vorging, hörten
wir die Köchin in den Gängen laufen und rufen:</p>
<p class="calibre1">»Der gnädige Herr muß schnell herunterkommen, die arme gnä' Frau
liegt im Sterben!« <a class="pcalibre2 pcalibre1 pcalibre pcalibre3" id="page21" title="ECeDee/Dieter7"></a></p>
<p class="calibre1">Mein Onkel war in Alissas Zimmer hinaufgegangen; meine Mutter
ging ihm entgegen. Als die beiden eine Viertelstunde darauf, ohne
dessen zu achten, vor den offenen Fenstern des Zimmers, in dem ich
geblieben war, vorübergingen, erreichte mich die Stimme meiner
Mutter: »Soll ich es dir sagen, mein Freund: all das ist Komödie!«
Und sie wiederholte mehrmals, indem sie die Silben trennte:
»Ko–mö–die!«</p>
<p class="calibre1">Das war gegen Schluß der Ferien und zwei Jahre nach unserer
Trauer. Ich sollte meine Tante lange nicht wiedersehen. Aber ehe
ich von dem traurigen Ereignis rede, das unsere Familie zerrüttete,
und von einem kleinen Umstand, der kurz vor der Katastrophe das
komplizierte und unbestimmte Gefühl, das ich Lucilie Bucolin
entgegenbrachte, in reinen Haß verwandelte, ist es Zeit, daß ich
von meiner Kusine spreche.</p>
<p class="calibre1">Daß Alissa Bucolin hübsch war, konnte ich noch nicht bemerken;
mich rief ein anderer Zauber zu ihr und fesselte mich an sie, als
der der einfachen Schönheit. Ohne Zweifel ähnelte sie ihrer Mutter
sehr; aber ihr Blick hatte einen <a class="pcalibre2 pcalibre1 pcalibre pcalibre3" id="page22" title="ECeDee/Dieter7"></a> so verschiedenen Ausdruck, daß mir
diese Ähnlichkeit erst später auffiel. Ich kann kein Gesicht
beschreiben; die einzelnen Züge entschlüpfen mir bis auf die Farbe
der Augen; ich sehe nur den schon fast traurigen Ausdruck ihres
Lächelns und die Linie ihrer Brauen, die sich über den Augen so
außerordentlich hoch erhoben und sich von ihnen in weitem Kreise
entfernten. Ich habe ihresgleichen nirgends wiedergesehen …
oder doch: bei einer florentinischen Statuette der Epoche Dantes;
und ich stelle mir gern vor, daß Beatrix als Kind sehr weit
gewölbte Augenbrauen hatte, gleich diesen. Sie gaben dem Blick, dem
ganzen Wesen den Ausdruck einer zugleich ängstlichen und
zuversichtlichen Frage – ja, einer leidenschaftlichen Frage. Alles
an ihr war nur Frage und Erwartung … Ich will erzählen, wie
dieses Fragen sich meiner bemächtigte, mein Leben bildete.</p>
<p class="calibre1">Juliette konnte indessen schöner scheinen; Freude und Gesundheit
gossen ihren Glanz über sie aus; aber ihre Schönheit schien neben
der Anmut ihrer Schwester äußerlich, so daß sie sich von selbst auf
einen einzigen Blick <a class="pcalibre2 pcalibre1 pcalibre pcalibre3" id="page23" title="ECeDee/Dieter7"></a> erschloß. Meinen Vetter Robert kennzeichnete
nichts Besonderes. Er war eben ein Junge in ungefähr meinem Alter.
Ich spielte mit Juliette und mit ihm; mit Alissa plauderte ich; sie
mischte sich kaum in unsere Spiele; so weit ich auch in die
Vergangenheit zurücktauche, ich sehe sie ernst, sanft lächelnd und
gesammelt. – Wovon plauderten wir? Wovon können zwei Kinder
plaudern? Ich will gleich versuchen, es zu sagen; aber zuvor will
ich, um nie wieder von ihr zu reden, zu Ende erzählen, was auf
meine Tante Bezug hat.</p>
<p class="calibre1">Zwei Jahre nach dem Tode meines Vaters kamen wir, meine Mutter
und ich, nach Le Havre, um dort die Osterferien zu verbringen. Wir
wohnten nicht bei den Bucolins, die in der Stadt in ihrem Raum
ziemlich beengt waren, sondern bei einer älteren Schwester meiner
Mutter, deren Haus geräumiger war. Meine Tante Plantier, die ich zu
sehen nur selten Gelegenheit hatte, war seit langem Witwe; kaum
kannte ich ihre Kinder, die viel älter waren als ich und ganz
anderen Charakters. Das »Haus Plantier«, wie man in Le Havre <a class="pcalibre2 pcalibre1 pcalibre pcalibre3" id="page24" title="ECeDee/Dieter7"></a> sagte, stand
nicht in der Stadt selbst, sondern auf halber Höhe jenes Hügels,
der die Stadt beherrscht und den man »La Côte« nennt. Die Bucolins
wohnten in der Nähe des Geschäftsviertels; eine steil abfallende
Gasse führte ziemlich schnell von einem Hause zum andern; ich
sprang mehrmals am Tage hinab und wieder hinauf.</p>
<p class="calibre1">An jenem Tage frühstückte ich bei meinem Onkel. Kurze Zeit nach
der Mahlzeit ging er aus; ich begleitete ihn bis in sein Bureau und
stieg dann wieder zum Hause Plantier hinauf, um meine Mutter zu
holen. Dort erfuhr ich, daß sie mit meiner Tante ausgegangen war
und erst zum Essen wiederkommen würde. Ich ging alsbald wieder in
die Stadt hinab, wo ich nur selten frei spazierengehen konnte, da
meine Mutter mich noch streng überwachte. Ich ging zum Hafen, den
ein Meeresnebel düster machte; ich irrte eine oder zwei Stunden auf
den Kais umher; ich sah den einlaufenden Barken zu und versuchte
mir meine Langeweile zu verhehlen. Unvermittelt kam mich der Wunsch
an, Alissa zu überraschen, die ich doch eben erst verlassen
hatte … Ich eile laufend durch <a class="pcalibre2 pcalibre1 pcalibre pcalibre3" id="page25" title="ECeDee/Dieter7"></a> die Stadt und schelle an der Tür der
Bucolins. Schon wollte ich mich in die Treppe stürzen, als mich das
Mädchen, das geöffnet hatte, aufhielt:</p>
<p class="calibre1">»Nicht hinaufgehn, Herr Jerome! Nicht hinaufgehn: die gnädige
Frau hat eine Krise.«</p>
<p class="calibre1">Aber ich eile weiter: – »Ich will nicht meine Tante
besuchen …« Alissas Zimmer liegt im dritten Stock. Im ersten
der Salon und das Speisezimmer; im zweiten das Schlafzimmer meiner
Tante, aus dem Stimmen herausdringen. Die Tür steht offen, und ich
muß an ihr vorüber. Ein Lichtstrahl fällt heraus und durchschneidet
den Treppenabsatz; aus Furcht, gesehen zu werden, zögere ich einen
Augenblick und verstecke mich. Und voll Entsetzen sehe ich dies:
mitten in dem Zimmer, dessen Vorhänge geschlossen sind, in dem aber
die Kerzen zweier Leuchter freudige Helle verbreiten, liegt meine
Tante auf einer Ottomane; zu ihren Füßen stehen Robert und
Juliette; hinter ihr ein unbekannter junger Mann in
Leutnantsuniform. Die Anwesenheit der beiden Kinder scheint mir
heute ungeheuerlich; in meiner damaligen Unschuld beruhigte sie
mich eher. <a class="pcalibre2 pcalibre1 pcalibre pcalibre3" id="page26" title="ECeDee/Dieter7"></a>
Sie sehen lachend den Unbekannten an, der mit Flötenstimme
wiederholt:</p>
<p class="calibre1">»Bucolin! Bucolin! … Wenn ich einen Hammel hätte, so würde
ich ihn sicherlich Bucolin nennen.«</p>
<p class="calibre1">Meine Tante selbst lacht schallend. Ich sehe, wie sie dem jungen
Mann eine Zigarette hinhält, die er anzündet und aus der sie ein
paar Züge raucht. Die Zigarette fällt zu Boden. Er stürzt hin, um
sie aufzuheben, tut, als strauchle sein Fuß über einen Schal und
fällt vor meiner Tante auf die Knie … Ich benutze dieses
lächerliche Schauspiel und gleite ungesehen vorbei.</p>
<p class="calibre1">Ich stehe vor Alissas Tür. Ich warte einen Augenblick. Das
Lachen und die Stimmen schallen aus dem unteren Stockwerk herauf;
und vielleicht übertönen sie das Geräusch meines Klopfens, denn ich
höre keine Antwort. Ich drücke gegen die Tür, die schweigend
nachgibt. Das Zimmer ist schon so finster, daß ich Alissa nicht
gleich erkenne; sie liegt am Kopfende ihres Bettes auf den Knien
und wendet dem Fenster, durch das ein sterbendes Licht hereinfällt,
<a class="pcalibre2 pcalibre1 pcalibre pcalibre3" id="page27" title="ECeDee/Dieter7"></a> den
Rücken. Sie wendet sich, doch ohne aufzustehen, als ich ihr nahe,
und murmelt:</p>
<p class="calibre1">»Oh, Jerome, weshalb kommst du wieder?«</p>
<p class="calibre1">Ich bücke mich, um sie zu küssen; ihr Gesicht ist von Tränen
überströmt …</p>
<p class="calibre1">Dieser Augenblick entschied über mein Leben; ich kann noch heute
nicht ohne Qual an ihn denken. Ohne Zweifel verstand ich den Grund
von Alissas Not nur recht unvollkommen; aber ich fühlte intensiv,
viel zu stark war sie für diese pochende kleine Seele, für diesen
gebrechlichen Leib, der ganz vom Schluchzen geschüttelt wurde.</p>
<p class="calibre1">Ich blieb bei ihr stehen, während sie auf den Knien blieb; ich
verstand von der neuen Entzückung meines Herzens nichts
auszusprechen; aber ich drückte ihren Kopf an mein Herz und auf
ihre Stirn meine Lippen, durch die sich meine Seele ergoß. Trunken
vor Liebe, vor Mitleid, vor einer unbestimmten Mischung von
Begeisterung, Entsagung und Tugend wandte ich mich mit all meinen
Kräften an Gott und bot mich dar, denn ich fand kein anderes Ziel
mehr für mein Leben, als das, dieses Kind gegen die Furcht, gegen
das Übel, gegen das Leben zu <a class="pcalibre2 pcalibre1 pcalibre pcalibre3" id="page28" title="ECeDee/Dieter7"></a> schirmen. Ich kniete endlich voll Andacht
nieder; ich zog sie wie in ein Asyl an mich, und undeutlich hörte
ich sie sagen: »Jerome, sie haben dich nicht gesehen, nicht wahr?
Oh, geh schnell! Sie dürfen dich nicht sehen …«</p>
<p class="calibre1">Dann, noch leiser: »Jerome, erzähle niemandem … Mein armer
Papa weiß nichts …«</p>
<p class="calibre1">Ich erzählte also meiner Mutter nichts; aber das nicht enden
wollende Geflüster meiner Tante Plantier mit ihr, die
geheimnisvolle, geschäftige und schmerzliche Miene dieser beiden
Frauen, das: »Mein Kind, geh dort hinten hin und spiele!« mit dem
sie mich fortschickten, so oft ich mich ihren geheimen
Besprechungen näherte – all das zeigte mir, daß ihnen das Geheimnis
des Hauses Bucolin nicht völlig unbekannt war.</p>
<p class="calibre1">Wir waren kaum wieder in Paris, als eine Depesche meine Mutter
von neuem nach Le Havre rief: meine Tante war geflohen.</p>
<p class="calibre1">»Mit irgend jemandem?« fragte ich Miß Ashburton, bei der meine
Mutter mich zurückließ.</p>
<p class="calibre1">»Liebes Kind, das mußt du deine Mutter fragen; ich kann dir
keine Antwort geben,« sagte <a class="pcalibre2 pcalibre1 pcalibre pcalibre3" id="page29" title="ECeDee/Dieter7"></a> diese gute alte Freundin, die dies Ereignis
niederschlug.</p>
<p class="calibre1">Zwei Tage darauf brachen wir auf, sie und ich, um meine Mutter
zu treffen. Es war ein Samstag. Ich sollte am folgenden Tage meine
Kusinen in der Kirche wiedersehen, und das allein beschäftigte mein
Denken, denn mein kindlicher Geist legte dieser Weihe unseres
Wiedersehens große Bedeutung bei. Schließlich kümmerte ich mich
wenig um meine Tante, und ich sah es als Ehrensache an, meine
Mutter nicht zu fragen.</p>
<p class="calibre1">In der kleinen Kapelle waren an jenem Tage nicht viele Leute.
Pastor Vautier hatte, offenbar absichtlich, zum Text seiner
Betrachtung die Worte Christi erwählt: »Gehet ein durch die enge
Pforte.«</p>
<p class="calibre1">Alissa saß ein paar Reihen vor mir. Ich sah ihr Gesicht im
Profil; ich blickte sie fest an, und zwar in solcher Vergessenheit,
daß mir war, als hörte ich diese Worte, auf die ich verloren
lauschte, durch sie hindurch. Mein Onkel saß neben meiner Mutter
und weinte.</p>
<p class="calibre1">Der Pastor hatte zunächst den ganzen Vers <a class="pcalibre2 pcalibre1 pcalibre pcalibre3" id="page30" title="ECeDee/Dieter7"></a> verlesen: »Gehet ein durch die
enge Pforte. Denn die Pforte ist weit, und der Weg ist breit, der
zur Verdammnis führt; und ihrer sind viele, die drauf wandeln. Und
die Pforte ist enge, und der Weg ist schmal, der zum Leben führet;
und wenig sind ihrer, die ihn finden.« Dann griff er die
Disposition des Themas auf und sprach zunächst vom breiten
Weg … Mit verlorenem Geist und wie im Traum sah ich das Zimmer
meiner Tante wieder; ich sah meine Tante wieder, wie sie dalag,
liebenswürdig, lächelnd; ich sah auch den glänzenden Offizier
wieder lachen … und schon der Gedanke des Lachens, der Freude
wurde verletzend, beschimpfend, wurde gleichsam zur scheußlichen
Offenbarung der Sünde! …</p>
<p class="calibre1">»Und ihrer sind viele, die drauf wandeln,« fuhr Pastor Vautier
fort; dann schilderte er, und ich sah sie, eine geputzte Menge, die
lachte und schäkernd daherzog und einen Aufzug bildete, in dem ich,
das fühlte ich, keinen Platz finden konnte, finden wollte, weil
mich jeder Schritt, den ich mit ihnen getan hätte, von Alissa
fortführen mußte. – Und der Pastor griff zurück auf den Anfang des
Textes, und ich sah <a class="pcalibre2 pcalibre1 pcalibre pcalibre3" id="page31" title="ECeDee/Dieter7"></a> diese enge Pforte, durch die man eingehen
mußte. Ich stellte sie mir in dem Traum, in den ich hinabtauchte,
vor als eine Kasteiungsmaschine, als eine Art Walzwerk, in das ich
mich nur mit Mühe und unter außerordentlichen Schmerzen
hineinzwängte, unter die sich jedoch schon ein Vorgeschmack der
Seligkeit des Himmels mischte. Und die Pforte wurde obendrein zur
Tür von Alissas Zimmer; um durch sie einzugehen, befreite,
entleerte ich mich all dessen, was noch vom Egoisten in mir
lebte … »Denn der Weg ist schmal, der zum Leben führt,« fuhr
Pastor Vautier fort – und jenseits jeder Kasteiung, jeder Trauer
dachte ich mir, ahnte ich eine andere, reine mystische, seraphische
Freude, nach der meine Seele schon dürstete. Ich stellte mir diese
Freude vor wie ein Violinspiel, das zugleich schrill und sanft ist,
wie eine spitze Flamme, in der Alissas und mein Herz sich
erschöpften. Beide traten wir vor, bekleidet mit jenen weißen
Gewändern, von denen die Apokalypse spricht; wir hielten uns an den
Händen und schauten aus nach einem und demselben Ziel … Was
frage ich, ob diese Kinderträume ein Lächeln entlocken; ich
wiederhole <a class="pcalibre2 pcalibre1 pcalibre pcalibre3" id="page32" title="ECeDee/Dieter7"></a>
sie, ohne etwas daran zu ändern. Die Verwirrung, die sich
vielleicht in ihnen zeigt, liegt nur in den Worten und in den
unvollkommenen Bildern, mit denen ich eine sehr bestimmte
Empfindung ausdrücken will.</p>
<p class="calibre1">»Und ihrer sind wenig, die ihn finden,« schloß Pastor Vautier.
Er erklärte, wie die enge Pforte zu finden sei … »Ihrer sind
wenig …« Ich wollte einer von ihnen sein! …</p>
<p class="calibre1">Ich war gegen das Ende der Predigt hin in einen solchen Zustand
moralischer Spannung geraten, daß ich, sowie der Gottesdienst
beendet war, ohne einen Versuch, meine Kusine zu sprechen, entfloh
– aus Stolz, denn ich wollte meine Entschlüsse (ich hatte solche
gefaßt) auf die Probe stellen und glaubte, sie nur um so mehr zu
verdienen, wenn ich mich auf der Stelle von ihr entfernte.</p>
<p class="calibre1">Was den Widerhall anging, den dieses Ereignis und diese
Ermahnung in ihr haben konnte, so kümmerte ich mich darum nicht
einen Augenblick. <a class="pcalibre2 pcalibre1 pcalibre pcalibre3" id="page33" title="ECeDee/Dieter7"></a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0002.vue?3683c8a2